import { React, useEffect } from "react";
import AOS from "aos";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import AboutImg from "../../Assets/AboutImg.svg";

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  const fontSize = {
    fontSize: "1.07rem",
  };
  return (
    <Container>
      <div
        id="about"
        className="d-flex flex-column-reverse flex-lg-row mx-auto text-center"
      >
        <div className="col-12 col-lg-6">
          <div
            className="row text-center pt-0 pt-md-2 pt-lg-5 mb-4"
            data-aos="fade-right"
          >
            <div className="col">
              <img
                src={AboutImg}
                style={{ maxHeight: "24rem" }}
                alt="ThumbsUp"
                className="img-fluid h-100 w-100 my-5 my-lg-0"
              />
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div
            className="pt-0 pt-lg-3 my-0 my-lg-5 text-center text-lg-start px-0"
            data-aos="fade-left"
            style={fontSize}
          >
            <h2 className="fw-semibold fs-2 fs-md-0 mt-3">Who We Are</h2>
            <p
              className="py-2 py-md-3 lh-lg text-center text-lg-start fs-md-0 w-100 mb-4 px-2 px-md-0"
              style={{ fontSize: 15.5 }}
            >
              Logistat is a Logistic-as-a-service (LaaS) technology platform
              that enables logistic companies in emerging markets to automate
              and scale their courier businesses by providing managed IT and
              business support services and fully customizable web and mobile
              user applications at an affordable rate.
            </p>
            <Link to="/About">
              <button
                className="btn btn-md text-white mb-3"
                type="button"
                onClick={() => {
                  window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                }}
                style={{ background: "#28B672" }}
              >
                Learn More
              </button>
            </Link>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default About;
